import React, { useState } from "react";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Row,
  Col,
} from "reactstrap";
import classnames from "classnames";
import "./Tabs.scss";
import { ITabs, ITabsData } from "../../../interfaces/Index";

const Tabs = (props: ITabs) => {
  const [activeTab, setActiveTab] = useState("1");

  const toggleTabs = (tab: string) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  // This component required object of array with id, tablink and content which will berendered
  // sample
  // const tabsData = [
  //   { id: "1", tabLink: "karachi", content: renderTabContent() },
  // ];

  return (
    <>
      <div className="tabs-container">
        <Nav tabs>
          {props.tabsData.map((item: ITabsData, i: number) => (
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === item.id })}
                onClick={() => {
                  toggleTabs(item.id);
                }}
              >
                {item.tabLink}
              </NavLink>
            </NavItem>
          ))}
        </Nav>

        <TabContent activeTab={activeTab}>
          {props.tabsData.map((item: ITabsData, i: number) => (
            <TabPane tabId={item.id}>
              <Row>
                <Col sm="12">{item.content}</Col>
              </Row>
            </TabPane>
          ))}
        </TabContent>
      </div>
    </>
  );
};

export default Tabs;
